enum ListingCardTypeEnum {
  Product = 'product',
  Promo = 'promo',
}

export default ListingCardTypeEnum;
